
import LeadCalculator from './components/LeadCalculator'

export default {
    el: '#vue_calculator',
    components: { LeadCalculator },
    template: '<LeadCalculator/>',
};
